module.exports = __webpack_public_path__ + "3ade38cacc96b849e8e525cca10efa7d.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/wechat.png
 ** module id = 1550
 ** module chunks = 0
 **/